import { css } from 'lit';

export default css`
  :host {
    --padding: 0;

    display: none;
  }

  :host([active]) {
    display: block;
  }

  .tab-panel {
    display: block;
    padding: var(--padding);
    /* pass a height given to the host through to the slotted content, so
     * fill-height children (e.g. tables that pin their paginator to the panel
     * bottom) can resolve their percentage heights; computes to auto and does
     * nothing while the host is content-height */
    height: 100%;
    box-sizing: border-box;
  }
`;
